import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { API } from 'constants';
import client from '../../services/library-api';

import { PLAYBOOK_VIEW_TYPE } from '../../constants/playbooks';

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useHandlePageDataLoadError } from '../../hooks/useHandlePageDataLoadError';

import Loading from '../../components/Loading';
import PlaybookTabsView from './PlaybookTabsView/PlaybookTabsView';
import PlaybookBlocksView from './PlaybookBlocksView/PlaybookBlocksView';

const PlaybookBuilderPage = () => {
    const { playbookId } = useParams();

    const navigate = useNavigate();
    const location = useLocation();
    const backLinkHref = location.state?.from || '/playbooks';

    const [playbookDetail, setPlaybookDetail] = useState(null);

    const view = playbookDetail?.default_view?.view_type;

    const [playbookContentData, setPlaybookContentData] = useState(null); // changing this state leads to refreshing playbookContentFormData state
    const playbookContentChangesState = useState(false);

    const { handlePageDataLoadError } = useHandlePageDataLoadError();

    useEffect(() => {
        const fetchPlaybookData = async () => {
            try {
                await refreshPlaybookData();
            } catch (e) {
                handlePageDataLoadError({
                    e,
                    redirectPath: backLinkHref,
                    generalErrorHandler: () => navigate(backLinkHref),
                });
            }
        };

        void fetchPlaybookData();
    }, []);

    const refreshPlaybookData = async () => {
        const { data } = await client.get(
            `${API.ROUTES.library.playbook}${playbookId}/?shared=True`
        );
        setPlaybookDetail(data);
        setPlaybookContentData(data.playbook_content);
    };

    useDocumentTitle(playbookDetail?.name);

    const commonProps = {
        playbookDetail,
        setPlaybookDetail,
        playbookContentData,
        backLinkHref,
    };

    return (
        <div className="page-position bg-white">
            {playbookDetail ? (
                <>
                    {view === PLAYBOOK_VIEW_TYPE.blocks && (
                        <PlaybookBlocksView
                            {...commonProps}
                            playbookContentChangesState={playbookContentChangesState}
                        />
                    )}

                    {view === PLAYBOOK_VIEW_TYPE.tabs && <PlaybookTabsView {...commonProps} />}
                </>
            ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <Loading />
                </div>
            )}
        </div>
    );
};

export default PlaybookBuilderPage;
